import type {UavPointCloudCreate} from '@/domain/entities/UavPointCloud';
import type {UavPointCloudRepository} from '@/domain/interfaces/UavPointCloudRepository';

export class CreateUavPointCloudsUseCase {
  constructor(private readonly repository: UavPointCloudRepository) {}
  async execute(entity: UavPointCloudCreate, file: File) {
    const pointCloud = await this.repository.create(entity);
    if (pointCloud) {
      const urls = await this.repository.getUrls(pointCloud.uuid);
      return this.repository.upload(urls.uploadUrl, file);
    }
  }
}
